// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__2mnfQ","loading":"skeleton_loading__OWXzz"};